import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    background-color: #fff;
    border-radius: 5px;
    margin-top: 10px;
    right: 50px;
    max-width: 360px;
    min-width: 250px;
    top: 70px;
    box-sizing: border-box;
    width: 100%;
    animation: fade 250ms;
    animation-fill-mode: backwards;
    z-index: 20;

    &::after {
        content: '';
        position: absolute;
        right: 10px;
        top: -11px;
        width: 0;
        height: 0;
        border-left: 18px solid transparent;
        border-right: 18px solid transparent;
        border-bottom: 15px solid #ffffff;
        clear: both;
    }

    @media (max-width: 768px) {
        max-height: 100%;
        max-width: 100%;
        margin: 0 10px;
        width: calc(100% - 20px);
        height: calc(100% - 65px);
        left: 0;
        right: 0;
        position: fixed;
        top: 55px;
        bottom: 0;

        &::after {
            right: 6px;
        }
    }

    .error-text:not(:empty) {
        padding-bottom: 10px;
    }

    .input-content {
        margin-bottom: 0;
    }

    .alelo_sad {
        width: 30px;
        height: auto;
        margin: 0 auto;
        display: block;
        margin-top: 25px;
    }

    .alelo_warning {
        width: 61px;
        height: 54px;
        margin: 0 auto;
        display: block;
        margin-top: 25px;
    }
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (max-width: 768px) {
        height: 100%;
        max-height: 100%;
        margin-bottom: 10px;
    }

    ::-webkit-scrollbar {
        padding-right: 100px;
        width: 6px;
        border-radius: 8px;
    }

    /* Cor de fundo da barra de rolagem */
    ::-webkit-scrollbar-track {
        background-color: white;
        border-radius: 8px;
    }

    /* Cor da alça (thumb) da barra de rolagem */
    ::-webkit-scrollbar-thumb {
        background-color: #d7d7d7;
        border-radius: 8px;
    }

    /* Borda ao redor da alça (thumb) */
    ::-webkit-scrollbar-thumb:hover {
        background-color: #d7d7d7;
        border-radius: 8px;
    }
`

export const Actions = styled.div`
    border-top: 1px solid rgba(151, 151, 151, 0.18);
    padding: 10px 24px 10px 24px;
    display: flex;
    flex-direction: column;

    #cartAddProducts,
    #cartSeeProposal,
    #cartDeleteProduct {
        width: 100%;
        font-size: 13px;
        font-weight: 900;
        padding: 15px 0;
        border-radius: 8px;
        margin-bottom: 15px;
    }

    #cartAddMoreProducts {
        margin-bottom: 15px;
    }

    @media (max-width: 768px) {
        flex-grow: 0;
    }
`

export const Warning = styled.div`
    @media (max-width: 768px) {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`

export const Desc = styled.div`
    display: block;
    text-align: center;
    padding: 10px 5px;
    width: 100%;
`

export const Label = styled.label`
    display: block;
    font-weight: 700;
    text-transform: uppercase;
    margin: 15px 0px;
`

export const Info = styled.span`
    display: block;
    text-align: center;
    font-size: 13px;
    color: #282828;
    font-weight: 300;
    padding: 5px;
    line-height: 21px;
`
